const RefundPolicy = () => (
  <div className="mb-16" id="refund-policy">
    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 pb-4 border-b-2 border-violet-500">
      Refund Policy
    </h2>

    <div className="space-y-8">
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 flex items-start">
          <i className="ri-time-line text-violet-600 mr-3 mt-1"></i>
          Service Cancellation &amp; Refund Eligibility
        </h3>
        <p className="text-base text-gray-700 leading-relaxed mb-4">
          At AZZ Matrix, we strive to provide exceptional IT services. If you are not satisfied with our services, you may request a refund under the following conditions:
        </p>
        <ul className="space-y-3 ml-8">
          <li className="flex items-start text-gray-700">
            <i className="ri-checkbox-circle-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span><strong>Service Plans:</strong> Refund requests must be submitted within 30 days of the initial service purchase or subscription start date.</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-checkbox-circle-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span><strong>One-Time Services:</strong> Refund requests for one-time IT services (such as network setup, cybersecurity audits, or cloud migration) must be made within 30 days of service completion.</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-checkbox-circle-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span><strong>Partial Refunds:</strong> If services have been partially rendered, refunds will be prorated based on the services already provided.</span>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 flex items-start">
          <i className="ri-close-circle-line text-violet-600 mr-3 mt-1"></i>
          Non-Refundable Items &amp; Services
        </h3>
        <p className="text-base text-gray-700 leading-relaxed mb-4">
          The following items and services are non-refundable:
        </p>
        <ul className="space-y-3 ml-8">
          <li className="flex items-start text-gray-700">
            <i className="ri-arrow-right-s-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span>Software licenses purchased through AZZ Matrix on behalf of the client</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-arrow-right-s-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span>Third-party hardware or equipment purchased for client infrastructure</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-arrow-right-s-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span>Custom development or consulting services that have been fully delivered</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-arrow-right-s-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span>Emergency IT support services rendered outside of regular business hours</span>
          </li>
          <li className="flex items-start text-gray-700">
            <i className="ri-arrow-right-s-fill text-violet-600 mr-3 mt-1 flex-shrink-0"></i>
            <span>Training sessions that have been completed</span>
          </li>
        </ul>
      </div>

      <div>
        <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4 flex items-start">
          <i className="ri-file-list-3-line text-violet-600 mr-3 mt-1"></i>
          How to Request a Refund
        </h3>
        <p className="text-base text-gray-700 leading-relaxed mb-4">
          To request a refund, please follow these steps:
        </p>
        <ol className="space-y-3 ml-8 list-decimal list-inside">
          <li className="text-gray-700 leading-relaxed">
            <strong>Contact Us:</strong> Email us at <a href="mailto:support@azzmatrix.com" className="text-violet-600 hover:text-violet-700 font-semibold">support@azzmatrix.com</a> with your order number and reason for the refund request.
          </li>
          <li className="text-gray-700 leading-relaxed">
            <strong>Review Process:</strong> Our team will review your request within 3–5 business days.
          </li>
          <li className="text-gray-700 leading-relaxed">
            <strong>Approval &amp; Processing:</strong> If approved, refunds will be processed within 7–10 business days to the original payment method.
          </li>
          <li className="text-gray-700 leading-relaxed">
            <strong>Notification:</strong> You will receive an email confirmation once the refund has been processed.
          </li>
        </ol>
      </div>

      <div className="bg-violet-50 border-l-4 border-violet-600 p-6 rounded-lg">
        <p className="text-sm text-gray-700 leading-relaxed">
          <strong className="text-violet-900">Note:</strong> Refund processing times may vary depending on your financial institution. Please allow up to 14 business days for the refund to appear in your account.
        </p>
      </div>
    </div>
  </div>
);

export default RefundPolicy;
